import CartSubtotal from './cartSubtotal';
import CartSummary from './cartSummary';
import DiscountCoupon from './discountCoupon';
import DiscountGiftcard from './discountGiftcard';
import Input from './input';
import Option from './option';
import PlainText from './plainText';

const controls = [
  CartSubtotal,
  CartSummary,
  DiscountCoupon,
  DiscountGiftcard,
  Input,
  Option,
  PlainText,
];

const getPrice = (priceElement) => {
  const control = controls.find((c) => c.matchType(priceElement));
  return control.extractPrice(priceElement).trim();
};

const setPrice = (priceElement, params) => {
  const control = controls.find((c) => c.matchType(priceElement));
  control.changePrice(priceElement, params);
};

const getElementState = (priceElement) => {
  const elementState = {
    htmlPrice: getPrice(priceElement),
    convertedCurrency: priceElement.getAttribute('simcase-converted-currency'),
    originalPrice: priceElement.getAttribute('simcase-original-price'),
    convertedPrice: priceElement.getAttribute('simcase-converted-price'),
  };

  return elementState;
};

const setElementState = (priceElement, state) => {
  priceElement.setAttribute(
    'simcase-converted-currency',
    state.convertedCurrency
  );
  priceElement.setAttribute('simcase-original-price', state.originalPrice);
  priceElement.setAttribute('simcase-converted-price', state.convertedPrice);

  setPrice(priceElement, state);
};

export { getElementState, setElementState };
